"use client";
import { useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import ImageComponent from "../common/ImageComponent";
import renderSkeleton from "../common/renderSkeleton";

import InnerImageZoom from "react-inner-image-zoom";

const ImageLoader = ({
  media,
  alt,
  skeletonStyle = {},
  imageStyle = {},
  width = null,
  height = null,
  skeletonHeight = null,
  skeletonWidth = null,
  imgRef = null,
  imgRes = "500",
  zoomImgRes = "800",
  zoom = false,
  zoomPreload = false,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [canUseHoverZoom, setCanUseHoverZoom] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mediaQuery = window.matchMedia("(hover: hover) and (pointer: fine)");
    const updateCanUseZoom = () => {
      const hasTouchPoints = navigator.maxTouchPoints > 0;
      setCanUseHoverZoom(mediaQuery.matches && !hasTouchPoints);
    };

    updateCanUseZoom();

    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", updateCanUseZoom);
      return () => mediaQuery.removeEventListener("change", updateCanUseZoom);
    }

    mediaQuery.addListener(updateCanUseZoom);
    return () => mediaQuery.removeListener(updateCanUseZoom);
  }, []);

  const getHighRes = (url, size) =>
    url
      ?.replace?.("r200x200", `r${size}x${size}`)
      ?.replace?.("v200x200", `v${size}x${size}`);

  const src = getHighRes(media?.mediaThumb, imgRes);
  const zoomUrl = getHighRes(media?.mediaThumb, zoomImgRes);

  if (!media?.mediaThumb) {
    return renderSkeleton(skeletonHeight, skeletonWidth, skeletonStyle);
  }

  const shouldUseZoom = zoom && canUseHoverZoom;

  return (
    <>
      {!imageLoaded &&
        renderSkeleton(skeletonHeight, skeletonWidth, skeletonStyle)}

      {shouldUseZoom ? (
        <InnerImageZoom
          src={src}
          zoomSrc={zoomUrl}
          zoomType="hover"
          zoomPreload={zoomPreload}
          className={`media-main-image ${!imageLoaded ? "hide" : ""}`}
          imgAttributes={{
            alt: alt || media?.mediaName || "",
            onLoad: () => setImageLoaded(true),
            style: {
              display: imageLoaded ? "block" : "none",
              transition: "opacity 0.3s ease",
            },
          }}
        />
      ) : (
        <ImageComponent
          crossOrigin="anonymous"
          src={src}
          alt={alt || media?.mediaName || ""}
          {...(width && { width })}
          {...(height && { height })}
          ref={imgRef}
          placeholder="blur"
          blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII="
          onLoad={() => setImageLoaded(true)}
          isLoaded={imageLoaded}
          style={{
            ...imageStyle,
            display: imageLoaded ? imageStyle.display || "block" : "none",
            transition: "opacity 0.3s ease",
          }}
        />
      )}
    </>
  );
};

export default ImageLoader;
